import { GlobalEvents } from '../../utils/event-emitter';

export default {
  methods: {
    openDialog() {
      this.globalEmitter.emit(GlobalEvents.INSERT_COMPONENT_DIALOG_OPEN);
    }
  }
};
